import { brand } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { h4, h6, paragraph, paragraphMicro, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.article `
  --avatarBorder: 8px;
  --avatarSize: 128px;
  --avatarTotalSize: calc(var(--avatarSize) + (var(--avatarBorder) * 2));
  padding: 0 12px;

  @media ${from(Device.MobileLarge)} {
    --avatarBorder: 10px;
    --avatarSize: 200px;
  }

  @media ${from(Device.Tablet)} {
    --avatarBorder: 12px;
    --avatarSize: 280px;
  }
`;
const ItemInner = styled.a `
  display: flex;
  align-items: center;
  background: var(--accentColor);
  border-radius: 14px;
  flex-direction: column;
  padding: 0 24px 40px;
  height: 100%;
  text-decoration: none;
  color: ${brand.black};
`;
const ImageWrapper = styled.div `
  position: relative;
  margin-top: calc(var(--avatarTotalSize) / 2 * -1);
`;
const Image = styled.img `
  display: block;
  border: 8px solid var(--bgColor);
  border-radius: 50%;
  height: var(--avatarTotalSize);
  width: var(--avatarTotalSize);
`;
const ItemName = styled.h3 `
  ${h4}
  margin: 24px 0 0;
`;
const ItemJobTitle = styled.p `
  ${paragraph}
  margin: 16px 0 0;
`;
const ContentWrapper = styled.div `
  padding: 32px 24px;
`;
const Metadata = styled.div `
  ${paragraphMicro}
  margin-bottom: 14px;
`;
const Date = styled.time `
  ${fonts.montserrat.bold}
`;
const Title = styled.h3 `
  ${h6}
  margin-bottom: 24px;
`;
const Content = styled.p `
  ${paragraphSmall}
  margin-bottom: 0;
`;
const CtaWrapper = styled.div `
  margin-top: auto;
  padding-top: 24px;
`;
const OurPeopleCardStyles = {
    Container,
    Content,
    ContentWrapper,
    CtaWrapper,
    Date,
    Image,
    ImageWrapper,
    ItemInner,
    ItemJobTitle,
    ItemName,
    Metadata,
    Title,
};
export default OurPeopleCardStyles;
